import { useEffect, useState } from 'react';

/**
 * Tracks a CSS media query in JS, for the handful of things Tailwind's
 * breakpoints cannot express on their own — swapping one component for a
 * completely different one, rather than just hiding and showing markup that
 * both stay mounted.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
